if (!customElements.get('ms-dog-tag-fields')) {
  customElements.define('ms-dog-tag-fields', class extends HTMLElement {
    connectedCallback() {
      if (this.onInput) return;
      this.validate = input => {
        const start = input.selectionStart;
        const end = input.selectionEnd;
        input.value = input.value.toUpperCase().replace(/[^A-Z0-9 ',.\-\/()@*+!?":#=&]/g, '').slice(0, 16);
        input.setSelectionRange(Math.min(start, input.value.length), Math.min(end, input.value.length));
        const supported = /^[A-Z0-9 ',.\-\/()@*+!?":#=&]{0,16}$/.test(input.value);
        input.setCustomValidity(supported ? '' : this.dataset.invalid);
      };
      this.validateGroup = () => {
        const inputs = [...this.querySelectorAll('[data-dog-tag-input]')];
        const hasText = inputs.some(input => input.value.trim());
        inputs[0]?.setCustomValidity(hasText ? '' : this.dataset.required);
      };
      this.onInput = event => {
        if (event.target.matches('input')) {
          this.validate(event.target);
          this.validateGroup();
          this.updatePreview();
        }
      };
      this.updatePreview = () => {
        const inputs = [...this.querySelectorAll('[data-dog-tag-input]')];
        const hasText = inputs.some(input => input.value.trim());
        this.querySelectorAll('[data-dog-tag-preview-line]').forEach((line, index) => {
          const value = inputs[index]?.value.trim();
          line.textContent = value || (index === 0 && !hasText ? 'DEIN TEXT' : '\u00a0');
        });
      };
      this.addEventListener('input', this.onInput);
      this.querySelectorAll('input').forEach(this.validate);
      this.validateGroup();
      this.updatePreview();
    }
    disconnectedCallback() {
      this.removeEventListener('input', this.onInput);
      this.onInput = null;
    }
  });
}
